// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileImageUpload-profileBackgroundImg-VU_NV {
  width: 92px;
  height: 92px;
  background-color: transparent;
  background-position: center;
  border-radius: 100px;
  background-size: contain;
  background-repeat: no-repeat;
}

.ProfileImageUpload-profileImageSize-MuGAU {
  padding: 13px;
  border-radius: 100px;
  border: 4px solid var(--primary-border);
}

.ProfileImageUpload-profileUpdateLoader-R3wM4 {
  border-radius: 100px;
}

.ProfileImageUpload-profileUpdateLoader-R3wM4 img {
  width: 92px !important;
  height: 92px !important;
  border-radius: inherit;
}`, "",{"version":3,"sources":["webpack://./src/components/ProfileCard/ProfileImageUpload/ProfileImageUpload.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".profileBackgroundImg {\n  width: 92px;\n  height: 92px;\n  background-color: transparent;\n  background-position: center;\n  border-radius: 100px;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.profileImageSize {\n  padding: 13px;\n  border-radius: 100px;\n  border: 4px solid var(--primary-border);\n}\n\n.profileUpdateLoader {\n  border-radius: 100px;\n}\n\n.profileUpdateLoader img {\n  width: 92px !important;\n  height: 92px !important;\n  border-radius: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profileBackgroundImg": `ProfileImageUpload-profileBackgroundImg-VU_NV`,
	"profileImageSize": `ProfileImageUpload-profileImageSize-MuGAU`,
	"profileUpdateLoader": `ProfileImageUpload-profileUpdateLoader-R3wM4`
};
module.exports = ___CSS_LOADER_EXPORT___;
